export default __webpack_public_path__ + "static/media/Logo_footer.44d58579.png";